<template>
  <section class="bottom-content" :style="`--primary-color:${primaryColor}`">
    <slot>
      <Link :href="href" :primary-color="primaryColor">
        {{ text }}
      </Link>
    </slot>
  </section>
</template>
<script>
export default {
  components: {
    Link: () => import('@/components/Prices/PricesHorizontal/Link')
  },
  props: {
    primaryColor: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom-content :not(a) {
  color: var(--primary-color);
}
</style>
